module.exports = __webpack_public_path__ + "static/media/examplePhoto.c74906a3.png";